

























































import Vue from 'vue'
import { mapGetters } from 'vuex'
import { RouteConfig, RawLocation } from 'vue-router'
import Icon from '@/components/Icon/Icon.vue'
import PaidLabel from '@/components/PaidLabel/PaidLabel.vue'
import PaidBadge from '@/components/PaidLabel/PaidBadge.vue'
import CustomSelect from '@/components/CustomSelect/CustomSelect.vue'
import CustomSelectCreateLink from '@/components/CustomSelect/CustomSelectCreateLink.vue'
import KnowledgeSectionComponent from '@/components/Knowledge/KnowledgeSection.vue'
import SidebarCloseButton from '@/components/Sidebar/SidebarCloseButton.vue'
import { KnowledgeAction } from '@/store/modules/knowledge/actions'
import { Modals } from '@/constants/modals'
import { KnowledgeBase, KnowledgeSection } from '@/models/knowledge'
import { Company } from '@/models/companies'
import { UserScope } from '@/models/users'
import { RouteNames } from '@/router'

interface Data {
  toKnowledgeView: Partial<RouteConfig>
}

interface Methods {
  handleSelectBaseId: (id: string) => void
  handleTogglePublished: (e: Event, item: KnowledgeBase) => void
  handleClickRouteLink: () => void
  handleShowPaymentModal: () => void
  getEditLink: (item: KnowledgeBase) => string
  getEditBasePermission: (baseCompanyId?: string) => boolean
  getKnowledgeRequiredPro: (item: KnowledgeBase) => boolean
}

interface Computed {
  bases: KnowledgeBase[]
  companyIsPro: boolean
  activeCompany: Company | undefined
  selectedBaseId?: string
  selectedBase?: KnowledgeBase
  createSectionLink?: RawLocation
  sections: KnowledgeSection[]
  isReadonly: boolean
  sectionsIsReadonly: boolean
  canDoScope: (checkingScope: UserScope) => boolean
}

export default Vue.extend<Data, Methods, Computed, {}>({
  components: {
    Icon,
    PaidLabel,
    PaidBadge,
    CustomSelect,
    CustomSelectCreateLink,
    KnowledgeSectionComponent,
    SidebarCloseButton,
  },
  data: function() {
    return {
      toKnowledgeView: {
        name: RouteNames.Knowledge,
      },
    }
  },
  computed: {
    ...mapGetters({
      bases: 'getKnowledgeBases',
      companyIsPro: 'getCompanyIsPro',
      activeCompany: 'getActiveCompany',
      selectedBaseId: 'getSelectedKnowledgeBaseId',
      canDoScope: 'canDoScope',
    }),
    isReadonly() {
      return !this.canDoScope(UserScope.KnowledgeEdit)
    },
    sectionsIsReadonly() {
      return !this.getEditBasePermission(this.selectedBase?.company_id)
    },
    selectedBase: {
      get() {
        return this.bases.find(b => b.id === this.selectedBaseId)
      },
      set(option) {
        if (option) {
          this.handleSelectBaseId(option.id)
        }
      },
    },
    sections() {
      return this.selectedBase?.sections || []
    },
    createSectionLink(): RawLocation | undefined {
      if (!this.selectedBaseId) {
        return
      }
      return {
        name: RouteNames.KnowledgeSection,
        params: {
          baseId: this.selectedBaseId,
        },
      }
    },
  },
  methods: {
    getEditBasePermission(baseCompanyId?: string): boolean {
      return (
        !this.isReadonly &&
        !!baseCompanyId &&
        `${this.activeCompany?.id}` === `${baseCompanyId}`
      )
    },
    getEditLink(item: KnowledgeBase): string {
      return `/${RouteNames.Knowledge}/${item.id}`
    },
    getKnowledgeRequiredPro(item: KnowledgeBase): boolean {
      return (
        !this.companyIsPro &&
        `${this.activeCompany?.id}` === `${item.company_id}`
      )
    },
    handleSelectBaseId(id: string): void {
      this.$store.dispatch(KnowledgeAction.SetSelectedBaseId, id)
    },
    handleTogglePublished(e: Event, item: KnowledgeBase): void {
      e.stopPropagation()
      const action = item.published
        ? KnowledgeAction.UnpublishBase
        : KnowledgeAction.PublishBase
      const payload = { id: item.id }
      this.$store.dispatch(action, payload)
    },
    handleClickRouteLink() {
      this.$emit('route-link-click')
    },
    handleShowPaymentModal() {
      this.$modal.show(Modals.TariffsModal)
    },
  },
})
